import {Modal} from "react-bootstrap";
import {Field} from "formik";
import {useIntl} from "react-intl";
import {AdminService, WLOCreditAPIService} from "../../../../services";
import {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {useRequestContext} from "../../../../hooks/useRequestContext";
import "./ModalReferences.scss";

interface ModalReferencesProps {
    show: boolean;
    onHide: () => void;
    errors?: any;
    values?: any;
    valorrequest?: boolean;
}

export function ModalReferences(props: ModalReferencesProps) {
    const {values, onHide, valorrequest} = props;
    const {request, setRequest} = useRequestContext();
    const [one] = useState(false);
    const [listReferencias, setListReferen] = useState<any[]>([]);

    useEffect(() => {
        getAll();
    }, [one]);

    const getAll = async () => {
        const refer = await AdminService.getReferencias();
        if (refer.payload.data.ListRef.Datos_Referencias.length > 0) {
            setListReferen(refer.payload.data.ListRef.Datos_Referencias);
        }
    };

    const handleSaveReference = (e: any) => {
        (async () => {
            e.preventDefault();
            if (valorrequest) {
                document.getElementById("boton_referencias")?.click();
            } else {
                if (values.s_ref_telfij) {
                    const references: any = await WLOCreditAPIService.addReferences({
                        s_num_solicitud: request.numSol,
                        s_identificacion: request.numIdentification!,
                        s_tipo_identificacion: request.typeIdentification!,
                        s_ref_tipo: values.s_ref_tipo!,
                        s_ref_parentes: values.s_ref_parentes!,
                        s_ref_nomcomple: values.s_ref_nomcomple!,
                        s_ref_telfij: values.s_ref_telfij!,
                        s_ref_telcel: values.s_ref_telcel!
                    });
                    if (references.payload.result === "1") {
                        const consultaReferences: any = await WLOCreditAPIService.addReferences({
                            s_num_solicitud: request.numSol,
                            s_identificacion: request.numIdentification!,
                            s_tipo_identificacion: request.typeIdentification!,
                        });

                        if (consultaReferences.payload.result > 0) {
                            values.s_ref_tipo = "";
                            values.s_ref_parentes = "";
                            values.s_ref_nomcomple = "";
                            values.s_ref_telfij = "";
                            values.s_ref_telcel = "";
                            let referencesFilter: any = consultaReferences.payload.data.datos_referencia.datos_refer.filter((item: { i_pws_num_solicitud: string | undefined; }) => item.i_pws_num_solicitud === request.numSol);
                            setRequest({...request, references: referencesFilter});
                            toast.success("Se agregado la referencia de manera exitosa", {
                                duration: 5000,
                            });
                        }
                    }
                } else {
                    toast.error("Debes colocar al menos el telefono 1", {
                        duration: 5000,
                    });
                }
            }
        })();
        onHide();
    };

    const intl = useIntl();
    return (
        <Modal
            {...props}
            size="lg"
            dialogClassName="reference-info-modal"
            aria-labelledby="contained-modal-title-center"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="title-modal-spouse">
                        {"Informaci\u00f3n de la referencia"}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="reference-modal-form">
                    <div className="reference-modal-grid reference-modal-grid--two">
                        <label className="reference-modal-field">
                            <span>{intl.formatMessage({id: "relationship"})}</span>
                            <Field as="select" name="s_ref_parentes">
                                <option value="">{intl.formatMessage({id: "relationship"})}</option>
                                {listReferencias.map((valor: any) => {
                                    return (
                                        <option key={valor.s_codigo} value={valor.s_codigo}>
                                            {valor.s_descripcion_legal}
                                        </option>
                                    );
                                })}
                            </Field>
                        </label>
                        <label className="reference-modal-field">
                            <span>Tipo de referencia</span>
                            <Field as="select" name="s_ref_tipo">
                                <option value="">Tipo de referencia</option>
                                <option value={"1"}>FAMILIAR</option>
                                <option value={"2"}>PERSONAL</option>
                            </Field>
                        </label>
                    </div>
                    <div className="reference-modal-grid reference-modal-grid--three">
                        <label className="reference-modal-field">
                            <span>Nombre completo</span>
                            <Field
                                id="s_ref_nomcomple"
                                name="s_ref_nomcomple"
                                placeholder="Nombre completo"
                            />
                        </label>
                        <label className="reference-modal-field">
                            <span>{intl.formatMessage({id: "placeholder_phone_1"})}</span>
                            <Field
                                id="s_ref_telfij"
                                name="s_ref_telfij"
                                placeholder={intl.formatMessage({id: "placeholder_phone_1"})}
                            />
                        </label>
                        <label className="reference-modal-field">
                            <span>{intl.formatMessage({id: "placeholder_phone_2"})}</span>
                            <Field
                                id="s_ref_telcel"
                                name="s_ref_telcel"
                                placeholder={intl.formatMessage({id: "placeholder_phone_2"})}
                            />
                        </label>
                    </div>
                    <div className="reference-modal-actions">
                        <button
                            type="button"
                            className="reference-modal-button reference-modal-button--secondary"
                            onClick={props.onHide}
                        >
                            {intl.formatMessage({id: "button_cancel"})}
                        </button>
                        <button
                            type="button"
                            className="reference-modal-button reference-modal-button--primary"
                            onClick={handleSaveReference}
                        >
                            {intl.formatMessage({id: "button_continue"})}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
